import { createContext } from 'react';

const MlbStatsContext = createContext({
  // isFetching: false,
  // data: {},
});

export default MlbStatsContext;
